import Approver from '../components/Approver.vue'
import Gateway from '../components/Gateway.vue'
import Event from '../components/Event.vue'
import ServiceButton from '../components/ServiceButton.vue'
import '@antv/x6-vue-shape'
import { Graph } from '@antv/x6'
import {
  EDGE_DEFAULT_COLOR,
  EDGE_GOING_COLOR,
  EDGE_PREDICT_COLOR,
} from '../const'

// 注册网关
Graph.registerNode(
  'Gateway',
  {
    inherit: 'vue-shape',
    width: 30,
    height: 30,
    component: Gateway,
  },
  true
)

// 注册Event
Graph.registerNode(
  'Event',
  {
    inherit: 'vue-shape',
    component: Event,
  },
  true
)

// 注册 审批人
Graph.registerNode(
  'Approver',
  {
    inherit: 'vue-shape',
    width: 60,
    height: 60,
    component: Approver,
  },
  true
)

// 注册 服务按钮
Graph.registerNode(
  'ServiceButton',
  {
    inherit: 'vue-shape',
    width: 90,
    height: 60,
    component: ServiceButton,
  },
  true
)

// 注册 内部子流程
Graph.registerNode(
  'SubProcess',
  {
    inherit: 'rect',
    zIndex: 1,
    attrs: {
      body: {
        fill: 'none',
        stroke: '#5a6dff',
        strokeWidth: 1,
        strokeDasharray: '1 2',
        rx: 10,
        ry: 10,
      },
    },
  },
  true
)

const edgeColorMap = {
  default: EDGE_DEFAULT_COLOR,
  going: EDGE_GOING_COLOR,
  predict: EDGE_PREDICT_COLOR,
}

const strokeWidthMap = {
  default: 1,
  going: 1,
  predict: 2,
}

const circleSizeMap = {
  default: 3,
  going: 3,
  predict: 4,
}

const strokeDasharrayMap = {
  default: '1 0',
  going: '1 0',
  predict: '2 2',
}

export function getEdgeAttrs(type = 'default') {
  const color = edgeColorMap[type]
  const circleSize = circleSizeMap[type]
  const strokeWidth = strokeWidthMap[type]
  const strokeDasharray = strokeDasharrayMap[type]

  return {
    line: {
      sourceMarker: {
        tagName: 'circle',
        r: circleSize,
        fill: color,
        stroke: color,
      },
      targetMarker: {
        tagName: 'circle',
        r: circleSize,
        fill: color,
        stroke: color,
      },
      strokeWidth: strokeWidth,
      stroke: color,
      strokeDasharray,
    },
  }
}
